import { fetchLocalites } from "../store/actions/adresseActions"
import { getBasePointInteret } from "./defaultObjects"
import { parseAdresseEmail, resolveLocalite } from "./parseAdresseEmail"
import { POINT_INTERET_TYPE_ADRESSE } from "../components/others/PointInteretComponent"

// « Utiliser cette adresse » (adresse lue dans un e-mail d'assistance) : POI
// ADRESSE pré-rempli depuis les 3 lignes de texte. La localité vient du NPA
// via les localités de CE NPA, chargées au clic (le store ne garde que la
// dernière recherche NPA) ; une localité déjà lisible dans l'e-mail reste
// prioritaire. `plusieurs` : le NPA a plusieurs localités, la première est
// posée et la liste sera ouverte. Partagé par la fiche mission (DepMissionV2)
// et les propositions d'assistance (GE-62, décision 1a).
export const adresseDepuisEmail = async (dispatch, [l0, l1, l2]) => {
	const lue = parseAdresseEmail(l0, l1, l2)
	let localites = null
	if (!lue.localite && lue.code_postal) {
		// Réseau en échec : l'adresse est posée quand même, localité vide
		// (toast via catchApiError dans le thunk).
		try {
			localites = await dispatch(
				fetchLocalites({ search: lue.code_postal }),
			)
		} catch (e) {
			localites = null
		}
	}
	const parsed = resolveLocalite(
		lue,
		Array.isArray(localites) ? localites : [],
	)
	const poi = getBasePointInteret(POINT_INTERET_TYPE_ADRESSE)
	return {
		poi: {
			...poi,
			adresse: {
				...poi.adresse,
				rue: parsed.rue,
				numero: parsed.numero,
				code_postal: parsed.code_postal,
				localite: parsed.localite,
				pays: parsed.pays,
			},
		},
		plusieurs: !!parsed.plusieurs,
	}
}
